import { useUserStore } from "../../state";
import TourGuideComponent from "./SideBar";

export const useCreateInventoryTourGuide = () => {
  const { user, updateProfile } = useUserStore();

  const createInventoryTourGuide = [
    {
      target: "#create-variations",
      content: (
        <TourGuideComponent
          body="Include products with different variations like Color or size on this tab."
          progress="Step 1 of 1"
          title="Product Option"
        />
      ),
      placement: "top" as const,
      locale: {
        skip: <span className="text-[#344054]">Skip</span>,
        next: <span className="text-[#ffffff] bg-transparent">Next</span>,
        last: (
          <span
            onClick={() => {
              updateProfile({
                prefs: {
                  ...user.prefs,
                  isFirstInventory: false,
                },
              });
            }}
            className="text-[#ffffff] bg-transparent"
          >
            Finish up
          </span>
        ),
      },
      showProgress: false,
      scrollOffset: 80,
      styles: {
        tooltip: { background: "#ffffff" },
        beaconInner: { background: "#ffffff" },
      },
    },
  ];

  return { createInventoryTourGuide };
};
